import React from "react"

import {
  INVESTMENT_PROFILE_TYPE_SDIRA,
  INVESTMENT_PROFILE_TYPE_ENTITY,
} from "@components/Domain/Constants"

import { getSdiraBusinessName, SdiraConnectBankAccountAlert } from "@components/Dwolla"

const updateMyInvestmentSourcesOperation = "investments/UpdateMyInvestmentSources"

const LABEL_SDIRA_CONNECT_SOURCE = "Connect Custodian Bank Account"


const getInvestmentSourceSelectProps = (identity, request, investment, syncInvestment, isSender = false) => {
  const {
    name: businessName,
    profileType,
    senderSourceId,
    receiverSourceId,
  } = investment

  const getMutation = (sourceId) => isSender
    ? {
        senderSourceId: sourceId
      }
    : {
        receiverSourceId: sourceId
      }

  const onSelect = (sourceId) =>
    request(updateMyInvestmentSourcesOperation, {
      id: investment.id,
      mutation: getMutation(sourceId)
    })
      .then(({ data }) => syncInvestment(data))

  const sourceId = isSender
    ? senderSourceId
    : receiverSourceId

  const props = {
    sourceId,
    onSelect,
  }

  const isEntity = profileType === INVESTMENT_PROFILE_TYPE_ENTITY

  if (isEntity) {
    props.businessName = businessName
  }

  const isSdira = profileType === INVESTMENT_PROFILE_TYPE_SDIRA

  if (isSdira) {
    const connectSourceHeader = <SdiraConnectBankAccountAlert />

    props.businessName = getSdiraBusinessName(businessName)
    props.isReceiveOnly = true
    props.dropdownProps = {
      connectSourceHeader,
      connectSourceTitle: LABEL_SDIRA_CONNECT_SOURCE
    }
  }

  return props
}

export default getInvestmentSourceSelectProps
